import {
	createAsyncThunk,
	createEntityAdapter,
	createSlice,
} from "@reduxjs/toolkit";
import axios from "axios";
import * as Models from "./models";
import * as Config from "./serverConfig";
// [DISABLED] Nominatim reverse geocoding — 暂时停用，服务配置有问题
// import { Nominatim } from "./NominatimReserveGeocoding";

// A login whose branch is not PGU / PKL / All holds a comma list of vehicle
// names instead (e.g. "MTL005" for the PKL login, 10/28). That account sees
// only those trucks, on every page. Returns null when the login is not limited.
const vehicleScope = (branch) => {
	const b = String(branch || "").trim();
	if (!b || ["ALL", "PGU", "PKL"].includes(b.toUpperCase())) return null;
	return b.split(",").map((v) => v.replace(/\s+/g, "").toUpperCase()).filter(Boolean);
};

export const getTrucks = createAsyncThunk("trucks/getTrucks", async (_, { getState }) => {
	const link = Config.Server?.link + "mode=getTrucksStat&company=" + (process.env.REACT_APP_GPS_COMPANY || "");
	let dataList = [];

	const response = await axios.get(link);
	const json = await response.data;

	if (json.success) {
		const scope = vehicleScope(getState().user?.data?.branch);
		const rows = scope
			? json.data.filter((item) => scope.includes(String(item.vehiclename || "").replace(/\s+/g, "").toUpperCase()))
			: json.data;
		// [DISABLED] Nominatim reverse geocoding 已停用
		// 如需重新启用，取消注释 Nominatim import 并恢复下方的地址查询逻辑
		dataList = rows.map((item) => {
			item.address = "";
			item.region = "";
			return new Models.TruckModel(item);
		});
		return dataList;
	} else {
		return {};
	}
});

const trucksAdapter = createEntityAdapter({});

export const { selectAll: selectTrucks, selectById: selectTruckById } =
	trucksAdapter.getSelectors((state) => state.trucks);

const Slice = createSlice({
	name: "trucks",
	initialState: trucksAdapter.getInitialState({
		searchText: "",
	}),
	reducers: {
		setTrucksSearchText: {
			reducer: (state, action) => {
				state.searchText = action.payload;
			},
			prepare: (event) => ({ payload: event.target.value || "" }),
		},
	},
	extraReducers: {
		[getTrucks.fulfilled]: trucksAdapter.setAll,
		// [removeMerchants.fulfilled]: (state, action) =>
		//   trucksAdapter.removeMany(state, action.payload),
	},
});

export const { setTrucksSearchText } = Slice.actions;

export const selectTrucksSearchText = ({ trucks }) => trucks.searchText;

export default Slice.reducer;
